import {Grid as MuiGrid} from '@material-ui/core';
import {useMemo} from 'react';

import clsx from 'clsx';
import withWidth from 'components/common/with-width';
import useStyles from './ItemStyles';

/**
 *
 * @param props {GridProps & { hide:boolean}}
 * @return {JSX.Element}
 * @constructor
 */
function Item(props) {
  const {children, className, hide, spacing, noPadding, noMargin: moduleNoMargin, ...rest} = props;
  const classes = useStyles(props);

  const noMargin = useMemo(() => spacing === 0 || moduleNoMargin, [moduleNoMargin, spacing]);

  return (
    <MuiGrid
      className={clsx(classes.item, className, {
        [classes.hide]: hide,
        [classes.noMargin]: noMargin,
        [classes.noPadding]: noPadding,
      })}
      item
      {...rest}
    >
      {children}
    </MuiGrid>
  );
}

export default withWidth(Item);
